import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'



export const get_category = createAsyncThunk(
  'category/get_category',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/category-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      )
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method


export const get_sub_categories = createAsyncThunk(
  'category/get_sub_categories',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_categories_subCategories = createAsyncThunk(
  'category/get_categories_subCategories',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-categories-subCategories', {
        withCredentials: true,
      })
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method



export const categoryReducer = createSlice({
  name: 'category',
  initialState: {
    successMessage: '',
    errorMessage: '',
    loader: false,
    categorys: [],
    subCategories: [],
    subCategory: '',
   
    category: '',
   
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      

      .addCase(get_categories_subCategories.fulfilled, (state, { payload }) => {
        state.categorys = payload.categories
      })

      .addCase(get_sub_categories.fulfilled, (state, { payload }) => {
        state.subCategories = payload.subCategories
      })

     
     
  },
})
export const { messageClear } = categoryReducer.actions
export default categoryReducer.reducer
